exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footerSourceModal h3{margin:1em 0!important}.footerSourceModal p{margin-bottom:1em!important}.footerSourceModal ul{list-style:inside!important;list-style-type:disc!important;padding-bottom:10px!important}.footerSourceModal a{color:#3273dc!important}.footerSourceModal-head{padding-top:5px!important;padding-bottom:5px!important}.footerSourceModal-title{padding-bottom:0!important;margin-bottom:0!important}.footerSourceModal-foot{padding-top:5px!important;padding-bottom:5px!important}", ""]);

// exports
